import { render } from "./P026.vue?vue&type=template&id=07b869bf&scoped=true"
import script from "./P026.vue?vue&type=script&lang=js"
export * from "./P026.vue?vue&type=script&lang=js"

import "./P026.vue?vue&type=style&index=0&id=07b869bf&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b869bf"]])

export default __exports__